import React from 'react';
import { withAuthorization } from '../../components/Session';
import { GoBackButton } from '../../components/Navigation';
import UserForm from './form';
import Spinner from '../../components/Spinner';

import Typography from '@material-ui/core/Typography';
// import * as ROLES from '../../constants/roles';
import { canDoSuperUserTasks } from '../../utils/utilities';

import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => ({
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  breadCrumbRow: {
    marginBottom: '-24px',
  },
});

class UserEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    Promise.all([this.getUser()]).then(() => {
      this.setState({ loading: false });
    });
  }

  getUser = () => {
    return this.props.firebase.user(this.props.user_id, false, { includeClients: true }).then((currentUser) => {
      this.setState({ currentUser });
    });
  };

  save = (user) => {
    this.setState({ loading: true });
    this.props.firebase.userUpdate(user).finally(() => {
      this.setState({ loading: false });
    });
  };

  delete = (user) => {
    this.setState({ loading: true });
    this.props.firebase
      .userDelete(user)
      .then(() => {
        this.props.history.push(`/admin/users`);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { lock_freight_forwarder } = this.props;
    const { currentUser, loading } = this.state;

    return (
      <div>
        <Spinner visible={loading} />
        {currentUser && (
          <div>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="h1">Edit User</Typography>
              </Grid>
              <Grid item xs={6}>
                <Grid container justifyContent="flex-end">
                  <GoBackButton />
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {/* prettier-ignore */}
                <UserForm
                                    lock_freight_forwarder={lock_freight_forwarder}
                                    user={currentUser}
                                    onSubmit={this.save}
                                    onDelete={this.delete}
                                    submitButtonText="Save Changes"
                                />
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

UserEditPage.propTypes = {
  classes: PropTypes.object.isRequired,
  user_id: PropTypes.string.isRequired,
};

// const condition = (authUser) => authUser && authUser.roles && authUser.roles.includes(ROLES.ADMIN);
const condition = (authUser) => canDoSuperUserTasks(authUser);

export default compose(withAuthorization(condition), withStyles(styles, { withTheme: true }))(UserEditPage);
